import { Box, Typography } from '@cambridgeassessment/cambridge-ui';
import { Link as LinkDS } from '@cambridgeassessment/cambridge-ui/build/components/Link';
import React, { useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import useOrgAssociateCenters from 'src/hooks/useOrgAssociates';
import { OrgAssociateCenter } from 'src/types';
import { filterOrgAssociateCenters } from 'src/utils/filterOrgAssociateCenters';
import OrgAssociateStatus from '../OrgAssociateStatus/OrgAssociateStatus';
import OverflowTooltip from '../OverflowTooltip/OverflowTooltip';
import { routes } from '../Pages';
import Table from '../Table/Table';
import UserStatusDescriptionCard from '../TooltipDescriptionCard/UserStatusDescriptionCard';
import { headCells } from './constants';
import { useUsersTableStyles } from './styles';
import { Columns, Row } from './types';
import { sortColumns } from './utils';

const tooltips = {
  status: <UserStatusDescriptionCard />,
};

export const createRows = (orgs: OrgAssociateCenter[]): Row[] => {
  return orgs.map((org: OrgAssociateCenter) => {
    return {
      cells: {
        [Columns.centerNumber]: (
          <Box data-sortvalue={org.centerNumber}>
            <OverflowTooltip variant="body1" data-testid="user-email">
              {org.centerNumber}
            </OverflowTooltip>
          </Box>
        ),
        [Columns.name]: (
          <Box data-sortvalue={org.centerName}>
            <OverflowTooltip variant="body1" data-testid="user-email">
              {org.centerName}
            </OverflowTooltip>
          </Box>
        ),
        [Columns.status]: (
          <OrgAssociateStatus status={org.status} data-sortvalue={org.status} />
        ),
        [Columns.link]: (
          <Typography variant="body1">
            <LinkDS
              component={Link}
              to={`${routes.MyOrganisation.path}/associate/child/${org.bpid}`}
              underline="none"
              tabIndex={0}
            >
              View
            </LinkDS>
          </Typography>
        ),
      },
      link: `${routes.MyOrganisation.path}/associate/child/${org.bpid}`,
    };
  });
};

const AssociatesTable: React.FC = () => {
  const {
    user: { isCambridgeAssessor },
  } = useAuth();
  const {
    isLoading,
    associateCenters,
    error,
    associateCenterTableSettings,
    searchQuery,
    updateAssociateCenterTableSettings,
    updateSearchQuery,
  } = useOrgAssociateCenters();
  useEffect(() => () => updateSearchQuery(''), []);

  console.log('>>>> associateCenters: ', associateCenters);
  const OrgAssociateCenters = filterOrgAssociateCenters(
    searchQuery,
    associateCenters
  );

  const rows = useMemo(() => {
    return createRows(OrgAssociateCenters);
  }, [OrgAssociateCenters]);

  const classes = useUsersTableStyles({ isCAS: isCambridgeAssessor });
  const noResultsMessage = (
    <Box>
      <Typography variant="body1">
        <Box display="flex" justifyContent="center">
          No results were found for&nbsp;
          <Typography variant="subtitle1">{searchQuery}</Typography>.
        </Box>
      </Typography>
      <Typography variant="body1">
        Check your spelling or try searching with another keyword.
      </Typography>
    </Box>
  );

  return (
    <Table
      loading={isLoading}
      error={!!error}
      noResultsMessage={noResultsMessage}
      headCells={headCells}
      rows={rows}
      tooltips={tooltips}
      sortColumns={sortColumns}
      settings={associateCenterTableSettings}
      updateSettings={updateAssociateCenterTableSettings}
      data-testid="assoicatesTable"
      className={classes.table}
    />
  );
};

export default AssociatesTable;
